import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {iDatenVersand, iFormDaten} from "./shared/entity/interfaces/allgemein";
import {DatenUploaderService} from "./shared/services/daten-uploader.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ProbenlisteComponent} from "./probenliste/probenliste.component";
import {InformationenComponent} from "./informationen/informationen.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  @ViewChild(InformationenComponent)
  private InformationenComponent!: InformationenComponent;
  @ViewChild(ProbenlisteComponent)
  private ProbenlisteComponent!: ProbenlisteComponent;
  public selectedTab ?: number = 0;

  constructor(private datenUploader: DatenUploaderService, private snackBar: MatSnackBar) {

  }

  probenListenDaten: iFormDaten = {header: [], daten: []};
  informationenFormDaten: iFormDaten = {header: [], daten: []};


  datenAbschicken() {
    if (this.InformationenComponent.getValidationStatus()) {
      this.ProbenlisteComponent.getValidationStatusObservable().subscribe((probenlisteIsValid) => {
        if (probenlisteIsValid) {
          let confirmation = confirm("Wollen Sie die Daten wirklich abschicken? \nBitte beachten: die Proben werden nach Abschluss der Untersuchung nicht asserviert oder eingefroren!")
          if (confirmation) {
            let datenObject = this.datenaufbereitung();
            this.datenUploader.datenUpload(datenObject, "/symfony/formDatenHandler").subscribe(data => {
              if(data.success)
              {
                let nachricht = data.nachricht ?? "";
                this.snackBar.open(nachricht, '', {
                  duration: 6000,
                  panelClass: 'success-snackbar'
                });
              }
              else{
                let nachricht = "Der Datenversand ist fehlgeschlagen: " + data.nachricht;
                this.snackBar.open(nachricht, '', {
                  duration: 12000,
                  panelClass: 'error-snackbar'
                });

              }

            });
          } else {
            let nachricht = "Datenversand wurde abgebrochen!";
            this.snackBar.open(nachricht, '', {
              duration: 6000,
              panelClass: 'success-snackbar'
            });
          }
        } else {
          let nachricht = "Es gibt noch Fehler in der Probenliste!";
          this.snackBar.open(nachricht, '', {
            duration: 6000,
            panelClass: 'error-snackbar'
          });
        }
      })
    } else {
      let nachricht = "Es gibt noch Fehler in den Informationen!";
      this.snackBar.open(nachricht, '', {
        duration: 6000,
        panelClass: 'error-snackbar'
      });
    }
  }
  private datenaufbereitung():object
  {
    let datenObject: iDatenVersand = {
      "probenliste": {daten: [], header: []},
      "informationen": {daten: [], header: []}
    }
    datenObject.probenliste.daten = this.ProbenlisteComponent.getTabellenDaten();
    datenObject.probenliste.header = this.ProbenlisteComponent.tableSettings.columns.map((column:{title: string;}) => column.title)
    datenObject.informationen.daten = Object.values(this.InformationenComponent.getFormValuesAndKeys()).map((item: any): string|object => {
      if (item.label !== undefined) {
        return item.label;
      } else if (typeof (item) === "string") {
        return item;
      } else if (typeof (item) === "object") {
        if (item.name !== undefined) {
          return item;
        } else {
          return item.toLocaleDateString('de-DE');
        }
      }
      return item;
    });

    datenObject.informationen.header = Object.keys(this.InformationenComponent.getFormValuesAndKeys());
    return datenObject;
  }
}
